export const InquiryCategory = {
  GENERAL: '일반 문의',
  ADVERTISING: '광고 문의',
  STORE: '스토어 문의',
} as const;

export const InquiryCategoryParent = {
  GENERAL: '일반 문의',
  STORE: '스토어 문의',
} as const;

export const FaqCategory = {
  ACCOUNT: '계정',
  PAYMENT: '결제',
  MY_CHILD: '나의 아동',
  CHILD_MANAGEMENT: '아동 관리',
  ETC: '기타',
} as const;

export const FaqCategoryParent = {
  ACCOUNT: '계정',
  PAYMENT: '결제',
  MY_CHILD: '나의 아동',
};

export const FaqCategoryMerged = {
  ACCOUNT: '계정',
  PAYMENT: '결제',
  CHILD_MANAGEMENT: '아동 관리',
  MY_CHILD: '나의 아동',
  ETC: '기타',
};
